var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSeychelles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5003:53620)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32.0107C24.8366 32.0107 32 24.8473 32 16.0107C32 7.17419 24.8366 0.0107422 16 0.0107422C7.16344 0.0107422 0 7.17419 0 16.0107C0 24.8473 7.16344 32.0107 16 32.0107Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.8001 4.2068C23.9539 1.60105 20.1625 0.0107422 15.9995 0.0107422C15.318 0.0107422 14.6465 0.0536797 13.9874 0.136367L6.26042 9.05424L0.505859 20.0189C0.877609 21.4602 1.44598 22.8224 2.1793 24.0762L15.9995 16.0107L26.8001 4.2068Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.3208 24.8757L6.9353 29.1957C9.51212 30.9708 12.6345 32.0109 16.0001 32.0109C21.5577 32.0109 26.4526 29.1769 29.3208 24.8757V24.8757Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.8034 4.20901L2.18945 24.0918C2.83327 25.1898 3.60408 26.2043 4.48202 27.1148L32.0006 16.0108C32.0006 11.3384 29.9974 7.13414 26.8034 4.20901V4.20901Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 16.011C0 17.3951 0.175875 18.7382 0.506312 20.0191L13.9878 0.136581C6.10112 1.12621 0 7.85596 0 16.011Z",
    fill: "#0052B4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5003:53620"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.0107422)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeychelles);
export default __webpack_public_path__ + "static/media/seychelles.eff47467.svg";
export { ForwardRef as ReactComponent };